exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rounded-circle[data-v-47c63b5a]{width:150px;height:150px}@media (max-width:768px){.rounded-circle[data-v-47c63b5a]{width:50px;height:50px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-47c63b5a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/contact/contact-card.vue
// module id = 1766
// module chunks = 0